import { initializeApp } from "firebase/app";
import { getMessaging, getToken, deleteToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "your_api_key_here",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "your_project_id.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "your_project_id_here",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "your_project_id.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "your_sender_id_here",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "your_app_id_here"
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const firebaseMessaging = getMessaging(firebaseApp);

/**
 * Refresh FCM token
 * @returns {Promise<string|null>} The new FCM token or null if failed
 */
export const refreshFCMToken = async () => {
  try {
    // Delete the current token first
    await deleteToken(firebaseMessaging);
    
    // Get a new token
    const newToken = await getToken(firebaseMessaging, {
      vapidKey: import.meta.env.VITE_VAPID_KEY || "your_vapid_key_here"
    });
    
    return newToken;
  } catch (error) {
    console.error('Error refreshing FCM token:', error);
    return null;
  }
};
